/**
 * Coverage summary sentence — extracted from CoverageInfo.tsx so the same
 * string can be reused by the chat empty-state (ChatEmptyState.tsx) without
 * duplicating the logic in two places (U2 PR2).
 */

import { COVERAGE, NOT_COVERED } from '../data/coverage';

// Human-friendly abbreviations for the sources we don't cover yet — used to
// build the coverage summary sentence below without hardcoding the whole list.
const NOT_COVERED_ABBREV: Record<string, string> = {
  'Corte Suprema y Cortes de Apelaciones': 'Cortes',
  'Contraloría General de la República': 'Contraloría',
};

const CORE_COVERAGE_TYPES = [
  'Oficios (jurisprudencia administrativa)',
  'Resoluciones',
  'Circulares',
  'Jurisprudencia (sentencias de los tribunales)',
];

/**
 * Builds the "Corpus consultado: ..." sentence shown in the coverage popover
 * and in the chat empty-state, generated from data/coverage.ts so ranges
 * stay in sync with the actual audited corpus instead of being duplicated
 * as literals.
 */
export function buildCoverageSummary(): string {
  const coreParts = COVERAGE.filter(e => CORE_COVERAGE_TYPES.includes(e.tipo)).map(e => {
    const shortTipo = e.tipo.split(' (')[0];
    const label = `${shortTipo} ${e.institucion} ${e.rango}`;
    const hasGap = e.tipo === 'Circulares' && /\b2019\b/.test(e.nota || '');
    return hasGap ? `${label} (sin 2019)` : label;
  });

  const notCoveredLabels = NOT_COVERED.map(item => NOT_COVERED_ABBREV[item] || item);
  const notCoveredText =
    notCoveredLabels.length > 1
      ? `${notCoveredLabels.slice(0, -1).join(', ')} ni ${notCoveredLabels[notCoveredLabels.length - 1]}`
      : notCoveredLabels.join('');

  return `Corpus consultado: ${coreParts.join(', ')}, Convenios de doble tributación y legislación núcleo. No incluye ${notCoveredText}.`;
}
